(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion"] && !Shopify.designMode) return;
  try {
    (() => {
    const TAG = 'accordion-custom';
    const DESKTOP_QUERY = '(min-width: 768px)';
    const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

    if (customElements.get(TAG)) return;

    /**
     * Where the sticky header will sit once the page scrolls. Its current
     * bottom is taller while a bar above it is still on screen, and using
     * that leaves the row short of the header after the bar scrolls away.
     */
    const stickyHeaderOffset = () => {
      const header = document.querySelector('.header-section');

      if (!(header instanceof HTMLElement)) return 0;

      const styles = getComputedStyle(header);

      if (styles.position !== 'sticky' && styles.position !== 'fixed') {
        return Math.max(0, header.getBoundingClientRect().bottom);
      }

      const top = Number.parseFloat(styles.top);
      const inset = Number.isFinite(top) ? Math.max(0, top) : 0;

      return inset + header.getBoundingClientRect().height;
    };

    /**
     * Sit the opened row just under the sticky header so the heading is at
     * the top of the screen. Skip only when it is already there.
     */
    const revealBelowHeader = (element, isCurrent) => {
      requestAnimationFrame(() => {
        if (!isCurrent() || !element.isConnected) return;

        const offset = stickyHeaderOffset();
        const { top } = element.getBoundingClientRect();
        const destination = Math.max(0, window.scrollY + top - offset);

        if (Math.abs(destination - window.scrollY) <= 1) return;

        window.scrollTo({
          top: destination,
          behavior: window.matchMedia(REDUCED_MOTION_QUERY).matches ? 'auto' : 'smooth',
        });
      });
    };

    const detailsContentDuration = (element) => {
      let styles;

      try {
        styles = getComputedStyle(element, '::details-content');
      } catch {
        return 0;
      }

      const properties = (styles.transitionProperty || 'none').split(',').map((part) => part.trim());
      const durations = (styles.transitionDuration || '0s').split(',').map((part) => part.trim());
      const index = properties.findIndex((property) => property === 'height' || property === 'all');

      if (index < 0) return 0;

      const raw = durations[index] || durations[0] || '0s';

      if (raw.endsWith('ms')) return Number.parseFloat(raw) || 0;
      if (raw.endsWith('s')) return (Number.parseFloat(raw) || 0) * 1000;

      return 0;
    };

    class AccordionCustom extends HTMLElement {
      #revealGeneration = 0;
      #cancelReveal = null;

      connectedCallback() {
        this.addEventListener('toggle', this.#handleToggle, true);
      }

      disconnectedCallback() {
        this.removeEventListener('toggle', this.#handleToggle, true);
        this.#stopReveal();
      }

      #stopReveal() {
        this.#revealGeneration += 1;
        this.#cancelReveal?.();
        this.#cancelReveal = null;
      }

      #shouldRevealRow() {
        if (window.matchMedia(DESKTOP_QUERY).matches) return false;

        return this.closest('product-details') instanceof HTMLElement;
      }

      /**
       * A row above this one shrinks as it closes, so the opened heading moves
       * after the tap. Wait out that height transition, then measure.
       */
      #revealRow(target, wait) {
        this.#cancelReveal?.();
        this.#cancelReveal = null;

        const token = ++this.#revealGeneration;

        const run = () => {
          if (this.#cancelReveal === cancel) this.#cancelReveal = null;
          if (token !== this.#revealGeneration || !this.isConnected || !target.open) return;
          if (window.matchMedia(DESKTOP_QUERY).matches) return;

          revealBelowHeader(
            target,
            () => token === this.#revealGeneration && target.isConnected && target.open
          );
        };

        const timer = window.setTimeout(run, wait);

        const cancel = () => {
          window.clearTimeout(timer);
          if (this.#cancelReveal === cancel) this.#cancelReveal = null;
        };

        this.#cancelReveal = cancel;
      }

      #handleToggle = (event) => {
        // Product overview (and theme-block accordions) keep one-at-a-time open.
        // FAQ metafield lists opt out via missing data-exclusive.
        if (!this.hasAttribute('data-exclusive')) return;

        const target = event.target;

        if (!(target instanceof HTMLDetailsElement) || !this.contains(target)) return;
        if (!target.open) return;

        const reveal = this.#shouldRevealRow();

        // Defer sibling closes. Synchronous closes during `toggle` break open /
        // close on iOS Safari when switching between rows.
        queueMicrotask(() => {
          if (!target.open || !this.isConnected) return;

          const closing = [];

          for (const details of this.querySelectorAll(':scope > details.accordion-row')) {
            if (details !== target && details.open) closing.push(details);
          }

          const above = closing.filter(
            (row) => (row.compareDocumentPosition(target) & Node.DOCUMENT_POSITION_FOLLOWING) !== 0
          );
          const wait = reveal
            ? above.reduce((max, row) => Math.max(max, detailsContentDuration(row)), 0)
            : 0;

          if (reveal) this.#revealRow(target, wait > 0 ? wait + 50 : 0);

          for (const details of closing) {
            details.open = false;
          }
        });
      };
    }

    customElements.define(TAG, AccordionCustom);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-specs-tooltip"] && !Shopify.designMode) return;
  try {
    (() => {
    const CLOSE_SELECTOR = '.product-specs__tooltip-close';
    const DETAILS_SELECTOR = 'details.product-specs__tooltip';
    const ITEM_SELECTOR = '.product-specs__item';
    const ITEM_OPEN_CLASS = 'product-specs__item--tooltip-open';

    if (document.documentElement.dataset.productSpecsTooltipCloseInit === 'true') return;

    document.documentElement.dataset.productSpecsTooltipCloseInit = 'true';

    const setItemOpenState = (details) => {
      const item = details.closest(ITEM_SELECTOR);

      if (!item) return;

      item.classList.toggle(ITEM_OPEN_CLASS, details.open);
    };

    document.addEventListener(
      'toggle',
      (event) => {
        const details = event.target;

        if (!(details instanceof HTMLDetailsElement) || !details.matches(DETAILS_SELECTOR)) return;

        setItemOpenState(details);
      },
      true
    );

    document.addEventListener('click', (event) => {
      const button = event.target.closest(CLOSE_SELECTOR);

      if (!button) return;

      const details = button.closest(DETAILS_SELECTOR);

      if (details instanceof HTMLDetailsElement) {
        details.open = false;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
